var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9998_84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 25C14 26.1 13.1 27 12 27C10.9 27 10 26.1 10 25C10 23.9 10.9 23 12 23C13.1 23 14 23.9 14 25ZM22 23C20.9 23 20 23.9 20 25C20 26.1 20.9 27 22 27C23.1 27 24 26.1 24 25C24 23.9 23.1 23 22 23ZM11 19C11 19.6 11.4 20 12 20H24V22H12C10.3 22 9 20.7 9 19C9 17.5 10 16.3 11.4 16.1L6.9 7H5V5H6.9C7.7 5 8.3 5.4 8.7 6.1L9.6 8H26C26.3 8 26.7 8.2 26.9 8.5C27.1 8.8 27.1 9.2 26.9 9.5L22.9 17.5C22.7 17.8 22.4 18 22 18H12C11.4 18 11 18.4 11 19ZM10.6 10L13.6 16H21.4L24.4 10H10.6Z",
    fill: "#606060"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9998_84"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy);
export default __webpack_public_path__ + "static/media/buy.ce71e351a18316bd17f06837aff307c5.svg";
export { ForwardRef as ReactComponent };